<template>
  <footer id="about" class="footer">
    <div class="footer-waves">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#9C27B0" fill-opacity="0.3" d="M0,192L48,192C96,192,192,192,288,176C384,160,480,128,576,133.3C672,139,768,181,864,186.7C960,192,1056,160,1152,138.7C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
      </svg>
    </div>
    
    <div class="container">
      <div class="footer-content">
        <div class="footer-section about">
          <div class="logo-text">幸福</div>
          <p>芝韵文化艺术(广州)有限公司致力于为用户提供最佳最简洁的中文输入体验。</p>
        </div>
        
        <div class="footer-section links">
          <h3>快速链接</h3>
          <ul>
            <li><a href="#download">下载中心</a></li>
          </ul>
        </div>
        
        <div class="footer-section contact">
          <h3>联系我们</h3>
          <p><strong>邮箱：</strong> fg2222222@qq.com</p>
          <p><strong>电话：</strong> 13717478432</p>

        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; 2025 芝韵文化艺术(广州)有限公司 版权所有 | <a href="#">隐私政策</a> | <a href="#">用户协议</a></p>
        <p class="icp-info"><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备2025410461号</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #37d5ff 0%, #37d5ff 100%);
  color: #f8f9fa;
  padding: 80px 0 20px;
  position: relative;
}

.footer-waves {
  position: absolute;
  top: -120px;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  z-index: -1;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-bottom: 60px;
}

.logo-text {
  font-size: 32px;
  font-weight: 800;
  color: #0099cc;
  margin-bottom: 20px;
  letter-spacing: -1px;
}

.footer-section p {
  margin-bottom: 15px;
  color: #0099cc;
  line-height: 1.6;
}

.footer-section h3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #0099cc;
  position: relative;
  display: inline-block;
}

.footer-section h3::after {
  content: '';
  position: absolute;
  width: 40px;
  height: 2px;
  background-color: #0099cc;
  bottom: -10px;
  left: 0;
}

.links ul {
  list-style: none;
  padding: 0;
}

.links li {
  margin-bottom: 12px;
}

.links a {
  color: #0099cc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.links a:hover {
  color: #006699;
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: #FF6B8B;
  transform: translateY(-3px);
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 153, 204, 0.3);
  color: #0099cc;
}

.footer-bottom p {
  margin-bottom: 8px;
}

.footer-bottom a {
  color: #0099cc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-bottom a:hover {
  color: #006699;
}

.icp-info {
  font-size: 14px;
  margin-top: 5px;
}

@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
  }
  
  .about {
    grid-column: span 2;
  }
}

@media (max-width: 576px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
  
  .about {
    grid-column: span 1;
  }
  
  .footer {
    padding-top: 60px;
  }
  
  .footer-waves {
    top: -50px;
  }
}
</style> 